import VerifyEmail from './VerifyEmailSuccess';
export default VerifyEmail;
